module.exports = __webpack_public_path__ + "static/media/noActivities.50ef6b08.png";